<router-outlet>
    <app-spinner></app-spinner>
</router-outlet>
<router-outlet name="print"></router-outlet>